import { memo } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { formattedValue, isValidDate } from "../../Services/common";
import { getColorOfStatus } from "../../Utils/appUtils";
import { changeDateFormatForDisplay } from "../../Utils/dateUtils";
import { slice } from "../../Utils/stringUtils";
import IconResource from "../../Wrapper/IconResource/IconResource";
import ImageResource from "../../Wrapper/ImageResource/ImageResource";
import AnimatedPage from "../AnimatedPage/AnimatedPage";
import Button from "../_widgets/Button/Button";
import DateRangePicker from "../_widgets/DateRangePicker/DateRangePicker";
import Input from "../_widgets/Input/Input";
import MainLoader from "../_widgets/Loader/MainLoader";
import MultiSelectDropdown from "../_widgets/MultiSelect/MultiSelectDropdown";
import NavBar from "../_widgets/NavBar/NavBar";
import CustomPagination from "../_widgets/Pagination/Pagination";
import Text from "../_widgets/Text/Text";
import CustomTooltip from "../_widgets/Tooltip/CustomTooltip";
import EditCreditNote from "./EditCreditNotes";
const CreditNotesUi = memo(
  ({
    searchQuery,
    setSearchQuery,
    dates,
    setDates,
    datePickerEndRef,
    datePickerStartRef,
    loading,
    onPageChange,
    getCreditNotesList,
    creditNotesList,
    modalShow,
    handleClose,
    handleSave,
    buttonLoading,
    modalLoading,
    selectLoading,
    creditNoteData,
    setCreditNoteData,
    fetchCreditCategories,
    getCreditCategoryList,
    setCategorySearch,
    setModalShow,
    openDetailsPage,
    statusOptions,
    statusFilter,
    handleStatusFilterChange,
  }) => {
    return (
      <>
        <EditCreditNote
          modelShow={modalShow}
          handleClose={handleClose}
          handleSave={handleSave}
          buttonLoading={buttonLoading}
          loading={modalLoading}
          selectLoading={selectLoading}
          creditNoteData={creditNoteData}
          setCreditNoteData={setCreditNoteData}
          fetchCreditCategories={fetchCreditCategories}
          getCreditCategoryList={getCreditCategoryList}
          setCategorySearch={setCategorySearch}
        />

        <AnimatedPage>
          <NavBar
            heading="Credit Notes"
            onClick={() => {
              document.body.classList.toggle("side_active");
              document.body.classList.toggle("side_active_mb");
            }}
            Icon="menu"
          />

          <div className="patient_list white_card">
            <div className="top_bar">
              <Text type="h2" text={""} />
              <div className="d-flex align-items-start align-items-md-center gap-3">
                <div className="bg_grey d-flex align-items-center justify-content-center position-relative px-2 py-1">
                  {statusFilter.length > 0 ? (
                    <div className="round-notification">{statusFilter.length}</div>
                  ) : (
                    ""
                  )}

                  <MultiSelectDropdown
                    items={statusOptions}
                    selectedOptions={statusFilter}
                    onChange={handleStatusFilterChange}
                    name={
                      <div className="d-flex align-items-center gap-1">
                        <IconResource type="filter" size={12} color={"var(--primary)"} />
                        <small
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "var(--primary)",
                            cursor: "pointer",
                          }}
                        >
                          Status
                        </small>
                        {statusFilter.length > 0 && (
                          <IconResource
                            type={"cross"}
                            size={12}
                            onClick={() => handleStatusFilterChange([])}
                          />
                        )}
                      </div>
                    }
                  />
                </div>

                <Row className="search_filter">
                  <Col lg={4}>
                    <Input
                      placeholder="Search"
                      id="searchInput"
                      suffixIcon="search"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      onClickIconSuff={() => getCreditNotesList()}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          getCreditNotesList();
                        }
                      }}
                      iconTooltip="Search"
                    />
                  </Col>
                  <Col lg={8}>
                    <DateRangePicker
                      startDate={dates?.startDate}
                      setStartDate={(startDate) => setDates({ ...dates, startDate })}
                      endDate={dates?.endDate}
                      setEndDate={(endDate) => setDates({ ...dates, endDate })}
                      onChange={(startDate, endDate) => setDates({ startDate, endDate })}
                      datePickerStartRef={datePickerStartRef}
                      datePickerEndRef={datePickerEndRef}
                      showDateShortcuts={true}
                    />
                  </Col>
                </Row>
              </div>
            </div>

            <div className="custom_table position-relative">
              {loading ? (
                <MainLoader />
              ) : creditNotesList?.data?.length > 0 ? (
                <>
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th>Bill No.</th>
                        <th>Bill Date</th>
                        <th style={{ width: "25%" }}>Medicine</th>
                        <th>Supplier</th>
                        <th>CN Amount</th>
                        <th>CN Number</th>
                        <th>CN Date</th>
                        <th>Status</th>
                        <th> Remarks</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {creditNotesList?.data?.map((data, index) => (
                        <tr
                          key={data.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            openDetailsPage(data.bill_no);
                          }}
                        >
                          <td>{data.bill_no || "-"}</td>
                          <td>
                            {isValidDate(data.product_detail?.bill_date)
                              ? changeDateFormatForDisplay(data.product_detail?.bill_date)
                              : "-"}
                          </td>
                          <td className="word-break" style={{ minWidth: "200px" }}>
                            <CustomTooltip text={data.product?.name} placement="top">
                              {data.product?.name || "-"}
                              <br></br>
                              <small>Batch: {data?.product_detail?.batch_number || "-"}</small>
                            </CustomTooltip>
                          </td>
                          <td>
                            <CustomTooltip
                              text={data?.product_detail?.supplier?.name}
                              placement="top"
                            >
                              {slice(data?.product_detail?.supplier?.name, 20) || "-"}
                            </CustomTooltip>
                          </td>
                          <td>{formattedValue(data.cn_amount, true, true)}</td>
                          <td>{data.cn_number || "-"}</td>
                          <td>
                            {isValidDate(data.return_date)
                              ? changeDateFormatForDisplay(data.return_date)
                              : "-"}
                          </td>
                          <td>
                            <div className={`status status__${getColorOfStatus(data.status)}`}>
                              <Text text={data.status} />
                            </div>
                          </td>
                          <td>
                            <CustomTooltip text={data.settled_remark} placement="top">
                              {slice(data.settled_remark, 20) || "-"}
                            </CustomTooltip>
                          </td>
                          <td>
                            <CustomTooltip text="Edit" placement={"top"}>
                              <Button
                                className="p-1 bg-transparent border-0"
                                icon={
                                  <IconResource
                                    type={buttonLoading === `edit${data.id}` ? "loader" : "edit"}
                                    color="var(--light-text)"
                                  />
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setCreditNoteData(data);
                                  setModalShow(true);
                                }}
                              />
                            </CustomTooltip>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <CustomPagination
                    activePage={creditNotesList?.current_page}
                    onPageChange={onPageChange}
                    pageLength={creditNotesList?.per_page}
                    totalData={creditNotesList?.total}
                    lastPage={creditNotesList?.last_page}
                  />
                </>
              ) : (
                <div className="no_data position-relative">
                  <ImageResource type="noData" style={{ width: "300px" }} className="img-fluid" />
                  <Text type="h2" text="There is no data to display. Try re-setting filters!" />
                </div>
              )}
            </div>
          </div>
        </AnimatedPage>
      </>
    );
  },
);

export default CreditNotesUi;
